// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__321iN","info":"Note_info__2-Jsg","note":"Note_note__2yEb2","actions":"Note_actions__1Foyz"};